import { render, staticRenderFns } from "./LookKPIScore.vue?vue&type=template&id=76c4f9dc&"
import script from "./LookKPIScore.vue?vue&type=script&lang=js&"
export * from "./LookKPIScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports